export default "__VITE_ASSET__3POQZu44__"